import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  heading: {
    id: 'searchPage.heading',
    defaultMessage: 'Tietojen haku',
  },
  description: {
    id: 'searchPage.description',
    defaultMessage: 'Toistaiseksi voi tehdä Trafi- ja luottotietohakuja vain tilaus- ja kuormakirjalomakkeista käsin.',
  },
})
